module.exports = __webpack_public_path__ + "media/application/images/icons/beans-537db1578e6dd9298f44fc18c9cc7647.svg";